import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import Select from "react-select"
import { SaveButton } from "components/Buttons"
import { syncOutlookCalendars } from "store/actions"

const SyncOutlookAddModal = ({
  calendar,
  outlookCalendars,
  onClose,
  syncOutlookCalendars,
  loading,
}) => {
  const [addCalendars, setAddCalendars] = useState("1")
  const [selectedCalendar, setSelectedCalendar] = useState(null)
  const [syncCancellation, setSyncCancellation] = useState(true)
  const [displayError, setDisplayError] = useState(false)

  useEffect(() => {
    if (
      calendar?.outlook_sync_calendars_add &&
      calendar?.outlook_sync_calendars_add?.length > 0
    ) {
      setAddCalendars("1")
      const calendarId =
        calendar?.outlook_sync_calendars_add[0]?.external_calendar_id
      const calendarData = outlookCalendars.find(
        item => item?.id === calendarId
      )
      setSelectedCalendar({
        value: calendarData?.id,
        label: calendarData?.summary,
      })
      setSyncCancellation(
        calendar?.outlook_sync_calendars_add[0]?.sync_cancellations
          ? true
          : false
      )
    } else {
      setAddCalendars("0")
    }
  }, [calendar])

  return (
    <React.Fragment>
      <Row className="form-check form-radio-outline form-radio-primary">
        <label className="form-check-label">
          <input
            name="addCalendars"
            type="radio"
            className="form-check-input"
            value="1"
            checked={addCalendars === "1"}
            onChange={e => {
              setAddCalendars(e.target.value)
            }}
          />
          {calendar?.outlook_connection?.outlook_email}
        </label>
      </Row>
      <Row className="form-check form-radio-outline form-radio-primary my-2">
        <label className="form-check-label">
          <input
            name="addCalendars"
            type="radio"
            className="form-check-input"
            value="0"
            checked={addCalendars === "0"}
            onChange={e => {
              setAddCalendars(e.target.value)
            }}
          />
          Do not add new events to a calendar
        </label>
      </Row>
      {addCalendars === "1" && (
        <React.Fragment>
          <Row className="mt-3">
            <label> Add to Calendar:</label>
          </Row>
          <Row>
            <Col xl={4}>
              <Select
                placeholder="Select Calendar"
                options={outlookCalendars
                  .filter(item => item?.isEditable)
                  ?.map(item => ({
                    label: item?.summary,
                    value: item?.id,
                  }))}
                value={selectedCalendar}
                onChange={e => {
                  setSelectedCalendar(e)
                  if (e) {
                    setDisplayError(false)
                  }
                }}
              />
            </Col>
          </Row>
          {displayError && (
            <Row>
              <div className="input-error">You have to select one calendar</div>
            </Row>
          )}
          <Row className="mt-4">
            <label>Sync Cancellations:</label>
          </Row>
          <Row className="form-check">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="checkbox"
                name={"syncCancellation"}
                checked={syncCancellation}
                onChange={event => {
                  setSyncCancellation(event.target.checked)
                }}
              />
              Deleting or declining an event in your calendar will also cancel
              it in enCappture.
              <br />
              If the event is a paid one, a refund wil be done.
            </label>
          </Row>
        </React.Fragment>
      )}
      <Row className="d-flex justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="light"
            onClick={onClose}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Save"
            loading={loading}
            onClick={() => {
              if (!selectedCalendar && addCalendars === "1") {
                setDisplayError(true)
              } else {
                syncOutlookCalendars({
                  values: {
                    calendar_id: calendar.id,
                    sync_type: 1,
                    type: 2,
                    sync_calendar_ids:
                      addCalendars === "1" ? [selectedCalendar?.value] : [],
                    sync_cancellations: syncCancellation,
                  },
                  callback: onClose,
                })
              }
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.BookingsFeature.loading,
})

const mapDispatchToProps = dispatch => ({
  syncOutlookCalendars: values => dispatch(syncOutlookCalendars(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SyncOutlookAddModal)
